import { render, staticRenderFns } from "./motion.vue?vue&type=template&id=0cbf71a6&scoped=true&"
import script from "./motion.vue?vue&type=script&lang=js&"
export * from "./motion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbf71a6",
  null
  
)

export default component.exports